import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DeficiencesService } from '../../services/deficiences/deficiences.service';
import { Deficiences } from '../../models/deficiences';
import { Access } from '../../models/access';

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { MustMatch } from '../../helpers/must-match.validator';
import { requiredIfValidator2 } from '../../helpers/check-required-private.validator';
import { requiredIfValidator } from '../../helpers/check-required-purchaser.validator';
import { RouterLink, RouterLinkActive } from '@angular/router';


@Component({
  selector: 'app-audit',
  templateUrl: './audit.html',
  styleUrls: ['./audit.css'],
  imports: [RouterLink, RouterLinkActive, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class Audit implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  auditForm: FormGroup;
  clicked: boolean = false;
  submitClicked: boolean = false;
  showMessage: boolean = false;
  submitted: boolean = false;
  showDivOtherDocumentType: boolean = false;
  response: string | undefined;
  showDivFileUploadMessage: boolean = false;
  showDivlast4SSN: boolean = false;
  showDivTIN: boolean = false;

  supportingDocuments: any = [];
  authenticatedUser: Access;
  requireDoc: boolean = false;
  requireTin: boolean = false;
  public claimant: Deficiences;
  public errorMessage: string = '';
  public showError: boolean;
  public submittedClaim: Deficiences;
  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private claimantService: DeficiencesService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private storage: LocalStorageService) { }

  ngOnInit() {
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.requireDoc = this.authenticatedUser.midocFlag === true;
    this.requireTin = this.authenticatedUser.mitinFlag === true;

    this.auditForm = this.fb.group({
      lucaClaimNumber: [this.authenticatedUser.lucaClaimNumber],
      phone1: [this.authenticatedUser.phone1],
      documentType: ['', this.requireDoc ? Validators.compose([Validators.required]) : null],
      otherDocumentType: [''],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      optTINSSN: ['', this.requireTin ? Validators.compose([Validators.required]) : null],
      sSN: ['', this.requireTin ? Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]) : null],
      tin: ['', this.requireTin ? Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]) : null],
      // signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])]
    });
  }




  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  // convenience getter for easy access to form fields
  get f() { return this.auditForm.controls; }

  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  getClaimantAccounTypeValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Other') {
      this.showDivOtherDocumentType = true;
      this.auditForm.get('otherDocumentType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value !== 'Other') {
      this.showDivOtherDocumentType = false;
      this.auditForm.get('otherDocumentType').clearValidators();
      this.auditForm.get('otherDocumentType').updateValueAndValidity();
      this.auditForm.get('otherDocumentType').reset();
    }
  }

  getOptTINSSNValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Last Four Of SSN') {
      this.showDivlast4SSN = true;
      this.showDivTIN = false;
      this.auditForm.get('sSN').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.auditForm.get('tin').clearValidators();
      this.auditForm.get('tin').updateValueAndValidity();
      this.auditForm.get('tin').reset();
    }

    if ($event.target.value === 'Tax Identification Number') {
      this.showDivTIN = true;
      this.showDivlast4SSN = false;
      this.auditForm.get('tin').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.auditForm.get('sSN').clearValidators();
      this.auditForm.get('sSN').updateValueAndValidity();
      this.auditForm.get('sSN').reset();
    }
  }

  getFileDetails(e) {
    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
      this.showDivFileUploadMessage = false;
    }
  }
  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }
  onSubmit() {
    this.submitted = true;
    if (this.auditForm.invalid) {
      return;
    }
    // require at least one uploaded document when the access record flags it as missing
    if (this.requireDoc && this.supportingDocuments.length == 0) {
      this.showDivFileUploadMessage = true;
      return;
    }
    this.submitClicked = true;
    this.clicked = true;
    const claimant = this.auditForm.value;

    this.spinner.show();
    this.CreateClaimant(claimant);
  }



  CreateClaimant(claimant: Deficiences) {
    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(claimNumber, this.supportingDocuments).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.dataSaved = true;
    // this.submitted = false;
    // this.notSubmitted = false;
    // this.message = "Record Saved Successfully";
    this.auditForm.reset();
    this.spinner.hide();
    this.router.navigate(['/audit-processing']);
  }

}
